<template>
  <div class="space-about h-full pb-2">
    <VuePerfectScrollbar class="attendance-scroll-area" :settings="settings">
      <h3>{{$t('HELP_ATTENDANCE').Title}}</h3>
      <span class="text-header">{{$t('HELP_ATTENDANCE').Contact_Text}}</span>
      <div class="box box-info-icon" v-if="$t('HELP_ATTENDANCE').Phone_Text">
        <feather-icon class="mr-0 cursor-pointer" icon="PhoneCallIcon" />
        {{$t('HELP_ATTENDANCE').Phone}} <a :href="$t('HELP_ATTENDANCE').Phone_href">{{$t('HELP_ATTENDANCE').Phone_Text}}</a>
      </div>
      <div class="box box-info-icon whatsapp">
        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32" width="32px" height="32px" fill-rule="evenodd" fill="currentColor"><path fill-rule="evenodd" d="M 24.503906 7.503906 C 22.246094 5.246094 19.246094 4 16.050781 4 C 9.464844 4 4.101563 9.359375 4.101563 15.945313 C 4.097656 18.050781 4.648438 20.105469 5.695313 21.917969 L 4 28.109375 L 10.335938 26.445313 C 12.078125 27.398438 14.046875 27.898438 16.046875 27.902344 L 16.050781 27.902344 C 22.636719 27.902344 27.996094 22.542969 28 15.953125 C 28 12.761719 26.757813 9.761719 24.503906 7.503906 Z M 16.050781 25.882813 L 16.046875 25.882813 C 14.265625 25.882813 12.515625 25.402344 10.992188 24.5 L 10.628906 24.285156 L 6.867188 25.269531 L 7.871094 21.605469 L 7.636719 21.230469 C 6.640625 19.648438 6.117188 17.820313 6.117188 15.945313 C 6.117188 10.472656 10.574219 6.019531 16.054688 6.019531 C 18.707031 6.019531 21.199219 7.054688 23.074219 8.929688 C 24.949219 10.808594 25.980469 13.300781 25.980469 15.953125 C 25.980469 21.429688 21.523438 25.882813 16.050781 25.882813 Z M 21.496094 18.445313 C 21.199219 18.296875 19.730469 17.574219 19.457031 17.476563 C 19.183594 17.375 18.984375 17.328125 18.785156 17.625 C 18.585938 17.925781 18.015625 18.597656 17.839844 18.796875 C 17.667969 18.992188 17.492188 19.019531 17.195313 18.871094 C 16.894531 18.722656 15.933594 18.40625 14.792969 17.386719 C 13.90625 16.597656 13.304688 15.617188 13.132813 15.320313 C 12.957031 15.019531 13.113281 14.859375 13.261719 14.710938 C 13.398438 14.578125 13.5625 14.363281 13.710938 14.1875 C 13.859375 14.015625 13.910156 13.890625 14.011719 13.691406 C 14.109375 13.492188 14.058594 13.316406 13.984375 13.167969 C 13.910156 13.019531 13.3125 11.546875 13.0625 10.949219 C 12.820313 10.367188 12.574219 10.449219 12.390625 10.4375 C 12.21875 10.429688 12.019531 10.429688 11.820313 10.429688 C 11.621094 10.429688 11.296875 10.503906 11.023438 10.804688 C 10.75 11.101563 9.980469 11.824219 9.980469 13.292969 C 9.980469 14.761719 11.050781 16.183594 11.199219 16.382813 C 11.347656 16.578125 13.304688 19.59375 16.300781 20.886719 C 17.011719 21.195313 17.566406 21.378906 18 21.515625 C 18.714844 21.742188 19.367188 21.710938 19.882813 21.636719 C 20.457031 21.550781 21.648438 20.914063 21.898438 20.214844 C 22.144531 19.519531 22.144531 18.921875 22.070313 18.796875 C 21.996094 18.671875 21.796875 18.597656 21.496094 18.445313 Z"/></svg>
        {{$t('HELP_ATTENDANCE').Whatsapp}} <a :href="$t('HELP_ATTENDANCE').Whatsapp_href" target="_blank">{{$t('HELP_ATTENDANCE').Whatsapp_Text}}</a>
      </div>
      <div class="box box-info-icon">
        <feather-icon class="mr-1 mb-1 cursor-pointer" icon="MailIcon" />
        {{$t('HELP_ATTENDANCE').Email}} <a :href="$t('HELP_ATTENDANCE').Mail_href">{{$t('HELP_ATTENDANCE').Mail_Text}}</a>
      </div>

      <div class="msg-form">{{$t('HELP_ATTENDANCE').Form_Text}}</div>

      <div class="attendance-form-content">
          <vs-input
          v-if="!isAuthenticated"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          :label="$t('REGISTER').Field_Username"
          name="nome"
          :placeholder="$t('REGISTER').Field_Username"
          v-model="form.name"
          class="w-full"
        />
        <vs-input
          v-if="!isAuthenticated"
          name="e-mail"
          type="email"
          icon-no-border
          icon="icon icon-mail"
          icon-pack="feather"
          :label="$t('REGISTER').Field_Email"
          :placeholder="$t('REGISTER').Field_Email"
          v-model="form.email"
          class="w-full"
        />
        <vs-input
          v-if="!isAuthenticated"
          :name="$t('HELP_ATTENDANCE').Phone"
          icon-no-border
          icon="icon icon-phone"
          icon-pack="feather"
          :label="$t('REGISTER').Field_Phone"
          :placeholder="$t('REGISTER').Field_Phone"
          v-model="form.phone"
          class="w-full"
          v-mask="'## #####-####'"
        />
          <vs-textarea class="w-full mt-4" v-model="form.message" height="100" :label="$t('HELP_ATTENDANCE').Form_Field_Message"/>
      </div>
      <div class="flex justify-center">
        <!-- <vs-button class="mr-3 mb-2 btn-login" @click="onSubmit">{{$t('BUTTONS').Send}}</vs-button> -->
        <vs-button class="w-full mb-2 btn-login" @click="onSubmit">{{$t('BUTTONS').Send}}</vs-button>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
  import attendanceService from "../../../providers/attendanceService";
  import messagesNotifyHelper from '../../../helpers/messages-notify-helper';
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    components: {
      VuePerfectScrollbar
    },
    props: {
      attendanceText: String
    },
    data() {
      return {
        form: {
          email: "",
          name: "",
          phone: "",
          message: ""
        },
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.5
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.state.isAuthenticated;
      },
    },
    methods: {
      onSubmit() {
        if (this.isAuthenticated) {
          this.form.email = this.$store.state.AppActiveUser.email;
          this.form.name = this.$store.state.AppActiveUser.nome;
          attendanceService
            .attendance(this.form, new URLSearchParams())
            .then(() => {
              this.form.question = "";
              messagesNotifyHelper.successNotify(
                this.$t('HELP_ATTENDANCE').Notify_Success_Title,
                this.$t('HELP_ATTENDANCE').Notify_Success_Message
              );
              this.clearData();
            })
            .catch(error => console.log(error));
        } else {
          attendanceService
            .publicAttendance(this.form, new URLSearchParams())
            .then(() => {
              this.form.question = "";
              messagesNotifyHelper.successNotify(
                this.$t('HELP_ATTENDANCE').Notify_Success_Title,
                this.$t('HELP_ATTENDANCE').Notify_Success_Message
              );
              this.clearData();
            })
            .catch(error => console.log(error));
        }

      },
      clearData() {
        this.form.message = '';
        this.form.phone = '';
        this.form.email = '';
        this.form.name = '';
      }
    },
    created() {
      if (this.attendanceText) {
        this.form.message = this.attendanceText;
      }
    }
  };
</script>

<style>

h3 {
  margin-bottom: 10px;
}

  .attendance-form-content {
    /* display: flex; */
  }
  .attendance-scroll-area {
    height: calc(100% - 30px);
    padding: 0px 20px 50px 20px;
  }
.theme-dark textarea.vs-textarea {
    /* background: #353e45;  */
}
.attendance-form-content .attendance-form-textarea {
  margin-left: 6px;
}
.box{
  margin-bottom: 10px;
}
.box.box-info-icon {
    padding-left: 30px;
}
.box.box-info-icon span svg {
    position: absolute;
    margin-top: -4px;
    margin-left: -30px;
    color: #2C2C2C;
    font-weight: bold;
}
.theme-dark .box.box-info-icon span svg {
  color: #9ec344
}
.msg-form{
  /* line-height: 40px; */
}
</style>
